import apiService from './api.service';

// Service for nursing career lead submissions
const NursingLeadService = (() => {

  return {
    // Submit nursing job application (multipart/form-data with CV attachment)
    submit: async (data: FormData) => {
      try {
        const response = await (await apiService).post('/website/nursing-jobs-in-new-zealand', data, false);
        return response;
      } catch (error) {
        throw error;
      }
    },

  };
})();

export default NursingLeadService;
